import React from "react";
import { useParams, Link } from "react-router-dom";
import { PublicNav } from "@/components/PublicNav";
import { Footer } from "@/components/Footer";
import { PrototypeBanner } from "@/components/PrototypeBanner";
import { ArrowLeft } from "lucide-react";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "La presente informativa descrive il trattamento dei dati personali su EtruriaCare, secondo i principi del GDPR e della privacy by design.",
    sections: [
      ["Dati raccolti", "Raccogliamo esclusivamente dati organizzativi necessari alla prenotazione: nome, recapiti, indirizzo della visita e preferenze di orario. Non raccogliamo diagnosi, referti, terapie o altri dati sanitari."],
      ["Finalità", "I dati sono utilizzati solo per gestire richieste, prenotazioni e comunicazioni organizzative tra paziente e professionista."],
      ["Consenso", "Il consenso al trattamento è raccolto in modo separato e non preselezionato, con registrazione di data e versione."],
      ["Diritti dell'interessato", "Puoi esportare i tuoi dati non clinici, disattivare l'account e richiedere la cancellazione dalla tua area personale."],
    ],
  },
  cookie: {
    title: "Cookie Policy",
    intro: "EtruriaCare utilizza cookie tecnici necessari al funzionamento del servizio e alla gestione della sessione autenticata.",
    sections: [
      ["Cookie tecnici", "Utilizziamo cookie di sessione (httpOnly) per mantenere l'accesso sicuro. Non sono usati per profilazione."],
      ["Cookie di terze parti", "Il pagamento in ambiente test può utilizzare cookie del provider Stripe limitatamente alla transazione."],
    ],
  },
  termini: {
    title: "Termini e Condizioni",
    intro: "EtruriaCare è un intermediario tecnologico che collega pazienti e professionisti sanitari.",
    sections: [
      ["Ruolo della piattaforma", "La valutazione clinica, la prestazione, il trattamento e le decisioni professionali restano di esclusiva responsabilità del professionista sanitario."],
      ["Prenotazioni", "Le prenotazioni sono soggette a conferma da parte del professionista. Le tariffe sono indicate prima della conferma."],
      ["Pagamenti demo", "In questo prototipo i pagamenti sono dimostrativi e non comportano addebiti reali."],
    ],
  },
  professionisti: {
    title: "Informativa Professionisti",
    intro: "Informazioni dedicate ai professionisti sanitari che aderiscono a EtruriaCare.",
    sections: [
      ["Verifica", "Prima di essere visibili ai pazienti, i profili vengono verificati: iscrizione all'albo, partita IVA e polizza RC."],
      ["Responsabilità", "Il professionista è unico responsabile della prestazione erogata e del rispetto delle normative sanitarie applicabili."],
      ["Compensi", "I compensi sono mostrati al netto della commissione di piattaforma, in modalità demo in questo prototipo."],
    ],
  },
  cancellazione: {
    title: "Politica di Cancellazione",
    intro: "Regole per la cancellazione e la modifica delle prenotazioni.",
    sections: [
      ["Annullamento", "Il paziente può annullare una prenotazione dalla propria area. In questo prototipo non sono applicate penali reali."],
      ["Modifiche", "Il professionista può proporre una fascia oraria alternativa, che il paziente può accettare o rifiutare."],
    ],
  },
};

export default function LegalPage() {
  const { slug } = useParams();
  const c = CONTENT[slug] || CONTENT.privacy;
  return (
    <div className="min-h-screen bg-white">
      <PrototypeBanner />
      <PublicNav />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <Link to="/" className="inline-flex items-center gap-2 text-[#087A73] font-semibold mb-6"><ArrowLeft className="h-4 w-4" /> Torna alla home</Link>
        <h1 className="text-3xl font-bold text-[#102A2A] mb-4">{c.title}</h1>
        <p className="text-[#5C6B68] leading-relaxed mb-8">{c.intro}</p>
        <div className="space-y-7">
          {c.sections.map(([t, body]) => (
            <div key={t}>
              <h2 className="text-lg font-bold text-[#102A2A] mb-2">{t}</h2>
              <p className="text-[#5C6B68] leading-relaxed">{body}</p>
            </div>
          ))}
        </div>
        <div className="mt-10 bg-[#EAF3EF] border border-[#D2E3DB] rounded-2xl p-5 text-sm text-[#5C6B68]">
          Documento placeholder a scopo dimostrativo. Prima dell'uso operativo è necessaria una revisione legale completa.
        </div>
      </div>
      <Footer />
    </div>
  );
}
